
import Vue from 'vue';
import SferumWebinarGroup from '@/pages/profile/components/infoSferum/SferumWebinarGroup.vue';

export default Vue.extend({
  name: 'InfoSferum',
  components: { SferumWebinarGroup },
  props: {
    items: {
      type: Array,
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/infoSferum/InfoSferum.vue